<template>
  <v-flex
    column
    role="region"
    aria-label="Gift page content"
  >
    <v-parallax
      src="https://gm.goz.fun/wp-content/uploads/2023/03/gifts-cover.png"
      height="350"
      aria-label="Gift section background image"
      role="img"
    />
    <v-card flat>
      <v-layout
        column
        pb-2
        role="region"
        aria-label="Gift dashboard"
      >
        <v-flex
          xs12
          sm12
          md12
          lg8
          justify-center
        >
          <v-card
            class="profile-section-card--flex-toolbar"
            flat
          >
            <v-progress-linear
              v-show="isLoading"
              color="accent"
              indeterminate
              role="progressbar"
              aria-label="Loading gifts"
            />
            <v-card flat>
              <v-container
                fluid
                grid-list-md
              >
                <v-tabs
                  fixed-tabs
                  color="accent"
                  show-arrows
                  centered
                  next-icon="fad fa-chevron-right"
                  prev-icon="fad fa-chevron-left"
                  slider-color="accent"
                  role="tablist"
                  aria-label="Gift tab navigation"
                >
                  <v-tabs-slider />
                  <v-tab
                    v-for="tab in tabs"
                    :key="tab.id"
                    :to="tab.route"
                    exact
                    role="tab"
                    :aria-label="tab.label || $t(`gift.tabs.${tab.id}`) || tab.id"
                    :aria-selected="$route.path === tab.route"
                    :tabindex="$route.path === tab.route ? 0 : -1"
                  >
                    <v-icon :aria-hidden="true">
                      {{ tab.icon }}
                    </v-icon>
                    <span class="sr-only">{{ tab.label || $t(`gift.tabs.${tab.id}`) || tab.id }}</span>
                  </v-tab>
                </v-tabs>
                <router-view
                  :zushin-points="zushinPoints"
                  role="region"
                  aria-live="polite"
                  aria-label="Gift content section"
                />
              </v-container>
            </v-card>
          </v-card>
        </v-flex>
      </v-layout>
    </v-card>
  </v-flex>
</template>

<script>
import { mapGetters } from "vuex";
import tabs from "@/constants/gift.tabs";

export default {
    name: "GiftLayout",
    data() {
        return {
            tabs: tabs.list,
            isLoading: false
        }
    },
    computed: {
        ...mapGetters(["zushinPoints"])
    }
};
</script>

<style lang="scss" scoped>
@import '~/_variables.scss';

    .gift-points {
        &-char {
            &-item{
                background: $secondary;
                padding: 0 1rem;
            }
        }
    }

.sr-only {
  position: absolute !important;
  width: 1px !important;
  height: 1px !important;
  padding: 0 !important;
  margin: -1px !important;
  overflow: hidden !important;
  clip: rect(0, 0, 0, 0) !important;
  white-space: nowrap !important;
  border: 0 !important;
}
</style>

